// extracted by css-extract-rspack-plugin
export default {"socialLink":"_a59e4d36","socialTooltip":"_11c1c2a3","socialIcon":"_68f2045d","reportWrapper":"_6e7d0fd0","flagIcon":"_bc195d2a"};